module.exports = __webpack_public_path__ + "static/media/margaret.2b29fbbd.png";